import {
  CorrectionType,
  IPayerTaxFormResponse,
  TaxFormCorrectionStatus,
  TaxFormEventDriver,
  TaxFormEventType
} from "@wingspanhq/payments/dist/interfaces";
import { ITaxFormRedactedEvent } from "@wingspanhq/payments/dist/interfaces/taxForm";
import { AlertProps } from "../../../../../shared/components/Alerts";

const isRecipientUpdateEvent = (
  event: ITaxFormRedactedEvent,
  taxFormCorrectionId: string
) => {
  return (
    event.correctionId === taxFormCorrectionId &&
    event.eventType === TaxFormEventType.RecipientUpdatedData &&
    event.triggeredBy === TaxFormEventDriver.Payee
  );
};

const isCompanyStructureChanged = (event: ITaxFormRedactedEvent) => {
  return (
    event.data?.w9Info?.companyStructure !==
    event.previousData?.w9Info?.companyStructure
  );
};

const isAddressChanged = (event: ITaxFormRedactedEvent) => {
  return (
    event.data?.w9Info?.addressLine1 !==
      event.previousData?.w9Info?.addressLine1 ||
    event.data?.w9Info?.city !== event.previousData?.w9Info?.city ||
    event.data?.w9Info?.state !== event.previousData?.w9Info?.state ||
    event.data?.w9Info?.postalCode !== event.previousData?.w9Info?.postalCode ||
    event.data?.w9Info?.country !== event.previousData?.w9Info?.country ||
    event.data?.w9Info?.addressLine2 !==
      event.previousData?.w9Info?.addressLine2
  );
};

export const getPayerTaxFormInformationUpdatedByRecipientAlerts = (
  taxForm: IPayerTaxFormResponse
): AlertProps[] => {
  const title = "Information updated by recipient";
  const theme = "info";

  const alerts: AlertProps[] = [];

  if (taxForm.corrections?.length) {
    const latestCorrection =
      taxForm.corrections[taxForm.corrections.length - 1];

    if (
      latestCorrection.status ===
        TaxFormCorrectionStatus.AppliedWithoutSubmission &&
      latestCorrection.correctionType === CorrectionType.None
    ) {
      if (
        taxForm.eventHistory?.some(
          event =>
            isRecipientUpdateEvent(
              event,
              latestCorrection.taxFormCorrectionId
            ) && isCompanyStructureChanged(event)
        )
      ) {
        alerts.push({
          title,
          theme,
          children: (
            <>
              The recipient updated their tax classification. Since their EIN
              and legal business name remain the same, no correction needs to be
              filed with the IRS.
            </>
          )
        });
      }

      if (
        taxForm.eventHistory?.some(
          event =>
            isRecipientUpdateEvent(
              event,
              latestCorrection.taxFormCorrectionId
            ) && isAddressChanged(event)
        )
      ) {
        alerts.push({
          title,
          theme,
          children: (
            <>
              The recipient updated their address. Since their State did not
              change, no correction needs to be filed with the IRS. If the
              recipient contacts you to re-mail their tax forms, their updated
              address will be used.
            </>
          )
        });
      }
    }
  }

  return alerts;
};
